export default "__VITE_ASSET__PMfrSC_N__"